// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__1WxTK","back":"style_back__1cA4a","submit":"style_submit__JQ4Z3","next":"style_next__2GSIY","next--full":"style_next--full__1J-9k"};